import React from 'react';
import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { currencyCommaConvert } from '@epi-helpers/numeral';
import { getBenefitIcon } from '@epi-constants/benefitTypes';
import { TopupReportsDetailsBoxProps } from '@epi-models/pages/Reports';
import { apiToDefaultDateFormat, isFuture } from '@epi-helpers/dateHelper';

import {
  DetailsBox,
  DetailsBoxHeader,
  StatusDot
} from '../../TopupReports.styles';
import { reportStatusesColors } from '../../../utils';

export const TopupReportsDetailsBox = ({
  reportDetails
}: TopupReportsDetailsBoxProps) => {
  const { t } = useTranslation();
  const { gray50 } = useTheme();

  return (
    <DetailsBox id="topup-reports-single-detail">
      <Box>
        <DetailsBoxHeader id="topup-reports-single-detail-date-head">
          {t('containers.deposit_money.reports_tab.create_at')}
        </DetailsBoxHeader>
        <Box id="topup-reports-single-detail-date">
          {apiToDefaultDateFormat(reportDetails.createdAt)}
        </Box>
      </Box>
      <Box>
        <DetailsBoxHeader id="topup-reports-single-detail-schedule-on-head">
          {t('containers.deposit_money.reports_tab.load_date')}
        </DetailsBoxHeader>
        <Box
          id="topup-reports-single-detail-schedule-on"
          color={isFuture(reportDetails.scheduledOn) ? gray50 : 'inherit'}
        >
          {apiToDefaultDateFormat(
            reportDetails.scheduledOn
              ? reportDetails.scheduledOn
              : reportDetails.createdAt
          )}
        </Box>
      </Box>
      <Box>
        <DetailsBoxHeader id="topup-reports-single-detail-load-id-head">
          {t('containers.deposit_money.reports_tab.load_id')}
        </DetailsBoxHeader>
        <Box id="topup-reports-single-detail-load-id">{reportDetails.id}</Box>
      </Box>
      <Box>
        <DetailsBoxHeader id="topup-reports-single-detail-executed_by-head">
          {t('containers.deposit_money.reports_tab.executed_by')}
        </DetailsBoxHeader>
        <Box id="topup-reports-single-detail-executed_by">
          {reportDetails.firstName} {reportDetails.lastName}
        </Box>
      </Box>
      <Box>
        <DetailsBoxHeader id="topup-reports-single-detail-status-head">
          {t('containers.deposit_money.reports_tab.status')}
        </DetailsBoxHeader>
        <Box
          display="flex"
          alignItems="center"
          id="topup-reports-single-detail-status"
        >
          <StatusDot $dotColor={reportStatusesColors[reportDetails.status]} />
          {t(
            `containers.deposit_money.reports_tab.statuses.${reportDetails.status}`
          )}
        </Box>
      </Box>
      <Box width="13%">
        <DetailsBoxHeader id="topup-reports-single-detail-benefit-head">
          {t('containers.deposit_money.reports_tab.benefit')}
        </DetailsBoxHeader>
        <Box id="topup-reports-single-detail-benefit">
          <Box mr={0.5} display="inline">
            {getBenefitIcon(t, reportDetails.benefitType)}
          </Box>
          {t(
            `containers.deposit_money.reports_tab.benefitTypes.${reportDetails.benefitType}`
          )}
        </Box>
      </Box>
      <Box>
        <DetailsBoxHeader id="topup-reports-single-detail-sum-head">
          {t('containers.deposit_money.reports_tab.sum')}
        </DetailsBoxHeader>
        <Box id="topup-reports-single-detail-sum" textAlign="right">
          {currencyCommaConvert(reportDetails.totalSum)}
        </Box>
      </Box>
      <Box>
        <DetailsBoxHeader id="topup-reports-single-detail-total-head">
          {t('containers.deposit_money.reports_tab.total')}
        </DetailsBoxHeader>
        <Box id="topup-reports-single-detail-total" textAlign="right">
          {currencyCommaConvert(reportDetails.totalSumWithFees)}
        </Box>
      </Box>
    </DetailsBox>
  );
};
